module.exports = __webpack_public_path__ + "img/user-08.jpg";